module.exports={...require("./error"),...require("./json"),...require("./missing"),...require("./status"),...require("./text")};